import { CIMSPage } from '../..'
import { NamedComplexEnum } from '../../utils/complexEnum/NamedComplexEnum'
import {
  Home,
  ImportsExports,
  CAS,
  DS,
  FDC,
  Concrete,
  Admin,
  PayItems,
  IFI,
  Issues,
  RFI,
  EJ,
  Developer,
  Materials,
} from './instances'

export type CIMSModuleItem =
  | typeof Home
  | typeof ImportsExports
  | typeof CAS
  | typeof DS
  | typeof FDC
  | typeof Concrete
  | typeof Admin
  | typeof PayItems
  | typeof IFI
  | typeof Issues
  | typeof RFI
  | typeof EJ
  | typeof Developer
  | typeof Materials

type Name = CIMSModuleItem['name']
type ID = CIMSModuleItem['id']

class CIMSModuleEnum extends NamedComplexEnum<
  'CIMSModule',
  CIMSModuleItem,
  Name,
  ID
> {
  readonly typename = 'CIMSModule'
  readonly Home = Home
  readonly ImportsExports = ImportsExports
  readonly CAS = CAS
  readonly DS = DS
  readonly FDC = FDC
  readonly Concrete = Concrete
  readonly Admin = Admin
  readonly PayItems = PayItems
  readonly IFI = IFI
  readonly Issues = Issues
  readonly RFI = RFI
  readonly EJ = EJ
  readonly Developer = Developer
  readonly Materials = Materials
  get values() {
    return [
      this.Home,
      this.ImportsExports,
      this.CAS,
      this.DS,
      this.FDC,
      this.Concrete,
      this.Admin,
      this.PayItems,
      this.IFI,
      this.Issues,
      this.RFI,
      this.EJ,
      this.Developer,
      this.Materials,
    ]
  }
  get pathnames() {
    return this.values.map(({ pathname }) => pathname)
  }
  pages(arg: ID | string | CIMSModuleItem) {
    return CIMSPage.findByModule(
      typeof arg === 'string' ? CIMSModule.fromIdOrFail(arg) : arg
    )
  }
}

export const CIMSModule = new CIMSModuleEnum()
